import React, { useEffect } from "react"
import { Container, Col } from "react-bootstrap"
import { useSelector, useDispatch, shallowEqual } from "react-redux"
import PolicyInformation from "./policyInformation"
import BenefitGroupSelection from "./benefitGroupSelection"
import BenefitSelection from "./benefitSelection"
import RequiredDocuments from "./requiredDocuments"
import BenefitFormsBase from "./benefitFormsBase"
import ReviewClaim from "./reviewClaim"
import SubmittedClaim from "./submittedClaim"
import { updateUiData } from "../../redux/actions"

import * as API from "../../services/httpService"
import { updateFromGetData } from "../../redux/actions"
import * as Constants from "../../common/constants"

// import { navigate } from "gatsby"

const BaseForm = () => {
  const uiData = useSelector(state => state.uiData)
  const { maxPageNumber } = uiData
  const claimData = useSelector(state => state.claimData, shallowEqual)

  // useEffect(() => {}, shallowEqual)
  const dispatch = useDispatch()
  useEffect(() => {
    API.apiPostRequest("/Claim/GetData", null, null).then(function(response) {
      let actionList = []
      if (response.data.policyNumber) {
        actionList.push(
          updateFromGetData("policyNumber", response.data.policyNumber)
        )
      }
      if (response.data.policyHolderName) {
        actionList.push(
          updateFromGetData("policyHolderName", response.data.policyHolderName)
        )
      }
      if (response.data.policyHolderNric) {
        actionList.push(
          updateFromGetData(
            "claimantNricNumber",
            response.data.policyHolderNric
          )
        )
      }
      if (response.data.claimantEmail) {
        actionList.push(
          updateFromGetData("claimantEmail", response.data.claimantEmail)
        )
      }
      if (response.data.claimantMobile) {
        actionList.push(
          updateFromGetData("claimantMobile", response.data.claimantMobile)
        )
      }

      if (response.data.sourceSystem) {
        actionList.push(
          updateFromGetData("sourceSystem", response.data.sourceSystem)
        )
      }

      if (response.data.hideHeaderFooter?.toLowerCase() == "true") {
        dispatch(updateUiData("hideHeaderFooter", true))
      }

      actionList.forEach((action, actionKey) => {
        dispatch(action)
      })
    })
  }, [dispatch])

  return (
    <>
      <Container className="body-content mt-md-4">
        {/* Pages
          1. Policy Information
          2. Benefit Group Selection
          3. Benefit Selection of chosen Group
          4. Upload supporting documents for selected benefit
          5. Benefit Form
          6. Summary
          7. Submitted Result
        */}

        <Col xs={12}>
          {/* 1. Policy Information */}
          {maxPageNumber >= Constants.policyInfoPageNumber && (
            <PolicyInformation claimData={claimData} uiData={uiData} />
          )}

          {/* 2. Benefit Group Selection */}
          {maxPageNumber >= Constants.benefitGroupPageNumber && (
            <BenefitGroupSelection claimData={claimData} uiData={uiData} />
          )}

          {/* 3. Benefit Selection of chosen Group */}
          {maxPageNumber >= Constants.benefitGroupPageNumber && (
            <BenefitSelection claimData={claimData} uiData={uiData} />
          )}

          {/* 4. Upload supporting documents for selected benefit */}
          {maxPageNumber >= Constants.benefitRequiredDocumentPageNumber && (
            <RequiredDocuments claimData={claimData} uiData={uiData} />
          )}

          {/* 6. Summary */}
          {maxPageNumber >= Constants.reviewPageNumber && (
            <ReviewClaim claimData={claimData} uiData={uiData} />
          )}

          {/* 5. All benefit form */}
          {maxPageNumber >= Constants.benefitFormPageNumber && (
            <BenefitFormsBase />
          )}

          {/* 7. Submitted Result */}
          {maxPageNumber === Constants.submittedClaimPageNumber && (
            <SubmittedClaim uiData={uiData}></SubmittedClaim>
          )}
        </Col>
      </Container>
    </>
  )
}

export default BaseForm
